import { FlagsHelpCenter } from "@/feature-flags/flags-help-center";

const Layout = () =>
  import(/* webpackChunkName: "Layout" */ "@/app/ui/layout/index.vue");
const HelpCenterPage = () =>
  import(
    /* webpackChunkName: "HelpCenter" */ "@/app/ui/views/help-center/index.vue"
  );

export default [
  {
    path: "/help-center",
    component: Layout,
    meta: {
      header: true,
      icon: "help-center",
      title: "Pusat Panduan",
      name: "Pusat Panduan",
      permission: FlagsHelpCenter.permission_help_center
    },
    children: [
      {
        path: "",
        name: "help-center",
        component: HelpCenterPage,
        meta: {
          header: true,
          title: "Pusat Panduan"
        }
      }
    ]
  }
];
